<template>

    <div class="container">

        <app-head title="Messages" />

        <div class="my-4 d-flex align-items-center">
            <h1>{{ __('Trash') }}</h1>
            <div class="ms-3">

            </div>
        </div>

        <div class="">
            <div class="">
                <navigation />
            </div>
            <div class="">
                <div class="border-bottom p-3">
                    <div class="row">
                        <div class="col-6">
                            <column-header label="Betreff" column="subject" :filters="filters" />
                        </div>
                        <div class="col-4">
                            <column-header label="Von" column="sender.name" :filters="filters" />
                        </div>
                        <div class="col-2">
                            <column-header label="Löschdatum" column="deleted_at" :filters="filters" />
                        </div>
                    </div>
                </div>
                <div class="list-group list-group-flush">
                    <template v-if="messages.meta.total">
                        <message 
                            v-for="message in messages.data" 
                            :message="message" 
                            :key="message.id" 
                            mode="trash"
                            />
                    </template>
                    <div class="list-group-item p-3" v-else>
                        {{ __('Keine Nachrichten') }}
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
    import Pagination from '@/shared/Pagination';
    import AccountLink from '@/shared/AccountLink';
    import SearchFilter from '@/shared/SearchFilter';

    import Message from './Message';
    import Navigation from './Navigation';
    import ColumnHeader from './ColumnHeader';

    export default {
        props: [
            'messages',
            'filters',
        ],
        data() {
            return {
                form: {
                    search: this.filters.search,
                },
            }
        },
        components: {
            Pagination,
            AccountLink,
            SearchFilter,
            Message,
            ColumnHeader,
            Navigation,
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('orders.index'), this.form, {preserveState: true, preserveScroll: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>